<!-- 基本信息 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header   flex flexColumn">
        <div class="head-title borderB">
          <div class="text">健管方案</div>
        </div>
        <div class="headSearch Fs14">
          <div class="headSearch-left">
            <div class="Search-condition">
              <div class="form-data group">
                <span>手机号码：</span>
                <el-input v-model="SearchForm.tel" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>客户姓名：</span>
                <el-input v-model="SearchForm.name" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>方案类型：</span>
                <el-select v-model="SearchForm.schemeType" filterable placeholder="请选择" clearable>
                  <el-option v-for="item in schemeTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
              <div class="form-data group">
                <span>方案名称：</span>
                <el-input v-model="SearchForm.schemeName" size="mini" placeholder="" clearable></el-input>
              </div>
            </div>
            <div class="Search-condition">
              <div class="form-data group">
                <span>方案机构：</span>
                <el-input v-model="SearchForm.institution" size="mini" placeholder="" clearable></el-input>
              </div>
              <div class="form-data group">
                <span>方案时间：</span>
                <el-date-picker size="mini" v-model="SearchForm.doTime" type="date" placeholder="选择日期"></el-date-picker>
              </div>
              <div class="form-data group">
                <span>创建时间：</span>
                <el-date-picker size="mini" v-model="SearchForm.time" type="date" placeholder="选择日期"></el-date-picker>
              </div>
              <div class="form-data group">
                <el-button @click="SearchBut" round type="primary" size="mini">搜索</el-button>
                <el-button @click="schemeAddBut" icon="el-icon-plus" round type="primary" size="mini">新增方案</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content" style="margin-top: 50px;">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="SchemeList.list"
          style="width: 100%">
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="name" label="客户姓名"> </el-table-column>
          <el-table-column prop="schemeType" label="方案类型" >
              <template slot-scope="scope">
                <span>{{ scope.row.schemeType | filterSchemeType }}</span>
              </template>
            </el-table-column>
          <el-table-column prop="schemeName" label="方案名称"> </el-table-column>
          <el-table-column prop="institution" label="方案机构"> </el-table-column>
          <el-table-column prop="doTime" label="方案时间">
            <template slot-scope="scope">
              <span>{{ scope.row.doTime | filterTime(1) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | filterTime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="schemeClick(scope.row)" type="primary" size="small">详情</el-button>
              <el-button @click="schemeDeleteClick(scope.row)" type="danger" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ SchemeList.total }}条记录，</span>
            <span class="pageNum">{{ SchemeList.pageNum }}</span>
            <span>/{{ SchemeList.pages }}页</span>
          </div>
          <el-pagination
            v-if="SchemeList !== ''"
            @current-change="handleCurrentChange"
            :current-page.sync="SchemeList.pageNum"
            :page-size="SchemeList.pageSize"
            layout="prev, pager, next, jumper"
            :total="SchemeList.total">
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增方案 -->
    <el-dialog title="方案编辑" width="800px" :visible.sync="schemeDialogVisible" :append-to-body="true" custom-class="outer-dialog" :close-on-click-modal="false">
      <el-form ref="schemeForm" :model="schemeForm" :rules="rules" label-width="100px">
        <el-card class="box-card">
          <el-row>
            <el-col :span="12">
              <el-form-item label="所属人员" prop="personId">
                <el-select v-model="schemeForm.personId" placeholder="请选择" filterable @change="bindPersonChange">
                  <el-option v-for="item in personOptions"
                    :key="item.id" :label="item.name + '/' +item.tel" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="客户姓名" prop="name">
                <el-input v-model="schemeForm.name" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="方案类型" prop="schemeType">
                <el-select v-model="schemeForm.schemeType" placeholder="请选择" filterable @change="bindSchemeTypeChange">
                  <el-option v-for="item in schemeTypeOptions"
                    :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="方案名称" prop="schemeNameSelect">
                <el-select v-model="schemeNameSelect" placeholder="请选择" filterable @change="bindSchemeNameChange">
                  <el-option v-for="item in schemeNameOptions"
                    :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案名称" prop="schemeName">
                <el-input v-model="schemeForm.schemeName" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="方案机构" prop="institution">
                <el-input v-model="schemeForm.institution" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="方案时间" prop="doTime">
                <el-date-picker v-model="schemeForm.doTime" type="date" placeholder="选择日期"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="note">
                <el-input v-model="schemeForm.note" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="box-card" style="margin-top: 10px;">
          <div slot="header" class="clearfix">
            <el-tag type="danger" effect="plain">方案附件</el-tag>
            <el-button @click="uploadClick" type="primary" size="small" round style="float: right;">上传</el-button>
            <el-table :data="schemeImgList" border style="width: 100%; margin-top: 20px;"
              :header-cell-style="{ background: '#f5f7fa !important' ,color:'#909399 !important'}">
              <el-table-column prop="imgName" label="文件名称" min-width="2"></el-table-column>
              <el-table-column prop="imgUrl" label="点击预览" min-width="1">
                <template slot-scope="scope">
                  <div v-if="scope.row.imgUrl.endsWith('.pdf')">
                    <a :href="scope.row.imgUrl" target="_blank" style="font-weight: 800; color: #33ab9e">点击预览</a>
                  </div>
                  <div class="demo-image__preview" v-else>
                    <el-image style="width: 100px; height: 100px" :src="scope.row.imgUrl" :preview-src-list="srcList"></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column min-width="1" label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger" icon="el-icon-delete" @click="tableDelete(scope.$index, scope.row)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="schemeDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="schemeUpdateBut">确 定</el-button>
      </div>
      <!-- 弹出框 -->
      <el-dialog :visible.sync="uploadDilaogVisible" :modal="false" width="500px" custom-class="inner-dialog" :close-on-click-modal="false">
        <el-form ref="uploadForm" :model="uploadForm" :rules="rules" label-width="80px">
          <el-form-item label="文件名" prop="imgName">
            <el-input v-model="uploadForm.imgName" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="选取文件" prop="imgUrl">
              <el-upload action="#" :limit="10" :file-list="fileList" multiple
              :http-request="uploadSectionFile" :on-exceed="handleExceed"
              :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
              <el-button size="mini" type="danger" icon="el-icon-upload"></el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="uploadDilaogVisible = false">取 消</el-button>
          <el-button type="primary" @click="uploadInBut">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>


  </div>
</template>

<script>
import { apiGetSchemePage, apiUpdateScheme, apiDeleteScheme, apiGetSchemeDtl } from '@/api/clientManage'
import { apiGetAlertPerson } from '@/api/alertManage'
import { apiUploadByBase64 } from '@/api/uploading'
let _self
export default {
  name: '',
  props: [''],
  data() {
    return {
      SchemeList: '', // 方案列表page
      SchemeTmplList: '',// 方案模板列表list
      pages: {
        page: 1, // 页数
        size: 50
      },
      SearchForm: {
        tel: '',
        name: '',
        schemeType: '',
        schemeName: '',
        institution: '',
        tester: '',
        doTime: '',
        time: '',
      },
      // 方案
      personOptions: [],
      personSelect: {},
      schemeForm: {},
      schemeDialogVisible: false,
      uploadDilaogVisible: false,
      schemeContentData: [],
      lastDoTime: null,
      schemeNameSelect: '',
      schemeTypeOptions: [
        {label: '身况', value: 6},
        {label: '营养', value: 1},
        {label: '饮食', value: 2},
        {label: '运动', value: 3},
        {label: '情绪', value: 4},
        {label: '习惯', value: 5},
      ],
      schemeNameOptions: [{label: '营养方案', value: '营养方案'}],
      // 上传
      uploadForm: {},
      fileList: [],
      imageUrl: '',
      dialogImageUrl: '',
      schemeImgList: [],
      srcList: [],
      
      rules: {
        personId: [
          { required: true, message: '请选择所属人员', trigger: 'blur' },
        ],
        name: [
          { required: true, message: '请输入客户姓名', trigger: 'blur' },
        ],
        schemeType: [
          { required: true, message: '请选择方案类型', trigger: 'blur' },
        ],
        schemeName: [
          { required: true, message: '请输入方案名称', trigger: 'blur' },
        ],
        schemeNum: [
          { required: true, message: '请输入方案编号', trigger: 'blur' },
        ],
        doTime: [
          { required: true, message: '请选择检测日期', trigger: 'blur' },
        ],
        institution: [
          { required: true, message: '请输入检测机构', trigger: 'blur' },
        ],
        tester: [
          { required: true, message: '请输入检测医生', trigger: 'blur' },
        ],
      },
    }
  },

  components: {  },

  computed: {},

  beforeMount() {},

  mounted() {
    _self = this
    this.GetSchemeList()
  },

  methods: {
    // 搜索
    SearchBut() {
      this.GetSchemeList()
    },
    // 列表-服务信息
    schemeClick(row) {
      this.schemeForm = {};
      this.schemeImgList = [];
      this.srcList = [];
      this.schemeNameSelect = '';
      apiGetSchemeDtl({
        id: row.id
      }).then(res => {
        if(res.status == 0) {
          this.schemeForm = res.data;
          if(this.schemeForm.urls == null) {
          } else {
            let urlArr = this.schemeForm.urls.split(",");
            let nameArr = this.schemeForm.unames.split(",");
            urlArr.forEach( (url, index) => {
              this.schemeImgList.push({imgName: nameArr[index], imgUrl: urlArr[index]});
            });
            this.calSrcList();
          }
          if(this.schemeForm.doTime) {
            this.schemeForm.doTime = new Date(this.schemeForm.doTime);
          }
          this.schemeDialogVisible = true;
          this.GetPersonList();
        }
      });
    },
    schemeDeleteClick(row){
        this.$confirm('确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            apiDeleteScheme({id: row.id}).then(res => {
              if (res.status === 0) {
                this.$message({message: '删除成功', type: 'success'});
                this.GetSchemeList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作'
            })
          })
      },
    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetSchemeList()
    },
    // 接口
    // 获取基本用户的列表
    GetSchemeList() {
      let doTimeLong = 0;
      let createTimeLong = 0;
      if(this.SearchForm.doTime) {
        doTimeLong = this.SearchForm.doTime.getTime();
      }
      if(this.SearchForm.createTime) {
        createTimeLong = this.SearchForm.createTime.getTime();
      }
      apiGetSchemePage({
        tel: this.SearchForm.tel,
        name: this.SearchForm.name,
        schemeType: this.SearchForm.schemeType,
        schemeName: this.SearchForm.schemeName,
        institution: this.SearchForm.institution,
        tester: this.SearchForm.tester,
        doTimeLong: doTimeLong,
        createTimeLong: createTimeLong,
        // doTime: this.SearchForm.doTime,
        // time: this.SearchForm.time,
        page: this.pages.page,
        pageSize: this.pages.size
      }).then(res => {
        if (res.status === 0) {
          this.SchemeList = res.data
          console.log('SchemeList', this.SchemeList)
        }
      })
    },
    GetPersonList() {
      apiGetAlertPerson({}).then( res => {
        if(res.status == 0) {
          this.personOptions = res.data;
        }
      });
    },

    // 方案
    clearForm() {
      this.schemeForm = {};
      this.schemeContentData = [];
      this.fileList = [];
      this.schemeImgList = [];
      this.srcList = [];
      this.schemeNameSelect = '';
    },
    schemeAddBut() {
      this.clearForm();
      this.schemeDialogVisible = true;
      this.GetPersonList();
    },
    schemeUpdateBut(row) {
      this.$refs['schemeForm'].validate(valid => {
        if (valid) {
          let urlArr = [];
          let nameArr = [];
          this.schemeImgList.forEach(f=>{
            urlArr.push(f.imgUrl);
            nameArr.push(f.imgName);
          });
          this.schemeForm.urls = urlArr.join(',');
          this.schemeForm.unames = nameArr.join(',');
          delete this.schemeForm.createTime;
          let doTimeLong = this.schemeForm.doTime.getTime();
          this.lastDoTime = this.schemeForm.doTime;
          delete this.schemeForm.doTime;
          this.schemeForm.doTimeLong = doTimeLong;
          apiUpdateScheme(this.schemeForm).then(res => {
            if (res.status === 0) {
              this.$message({message: '保存成功', type: 'success'});
              this.schemeDialogVisible = false;
              this.clearForm();
              this.GetSchemeList();
            } else {
              this.schemeForm.doTime = this.lastDoTime;
              this.$message({message: '上传失败', type: 'error'});
            }
          });
        }
      });
    },
    bindPersonChange() {
      this.personOptions.forEach( po=>{
        if(this.schemeForm.personId == po.id) {
          this.schemeForm.name = po.name;
          return;
        }
      });
    },
    bindSchemeTypeChange() {
      if(this.schemeForm.schemeType == 1) {
        this.schemeNameOptions = [{label: '营养方案', value: '营养方案'}];
      } else if(this.schemeForm.schemeType == 2) {
        this.schemeNameOptions = [{label: '饮食方案', value: '饮食方案'}];
      } else if(this.schemeForm.schemeType == 3) {
        this.schemeNameOptions = [{label: '运动方案', value: '运动方案'}];
      } else if(this.schemeForm.schemeType == 4) {
        this.schemeNameOptions = [{label: '情绪方案', value: '情绪方案'}];
      } else if(this.schemeForm.schemeType == 5) {
        this.schemeNameOptions = [{label: '习惯方案', value: '习惯方案'}];
      } else if(this.schemeForm.schemeType == 6) {
        this.schemeNameOptions = [{label: '身况方案', value: '身况方案'}];
      }
    },
    bindSchemeNameChange() {
      this.schemeNameOptions.forEach( rn=>{
        if(this.schemeNameSelect == rn.label) {
          this.$set(this.schemeForm, 'schemeName', rn.value);
          return;
        }
      });
    },

    uploadClick() {
      this.fileList = [];
      this.uploadForm = {};
      let rn = this.schemeForm.schemeName;
      if(rn) {
        this.$set(this.uploadForm, 'imgName', rn);
      }
      this.uploadDilaogVisible = true;
      console.log("上传");
    }, 
    tableDelete(index, row){
      // 删除模板项目
      this.$confirm('确认删除？')
          .then(_ => {
            this.schemeImgList.splice(index, 1);
            this.calSrcList();
          })
          .catch(_ => {});
    },
    uploadInBut() {
      let imgName = this.uploadForm.imgName;
      if(imgName == null || imgName == undefined || imgName == '') {
        this.$message.error('请填写文件名');
        return;
      }
      if(this.fileList == null || this.fileList.length == 0) {
        this.$message.error('请至少上传一个文件');
        return;
      }
      if(this.fileList.length > 1) {
        this.fileList.forEach((fl, index) => {
          let tmpName = imgName + '-' + (index+1);
          this.schemeImgList.push({imgName: tmpName, imgUrl: fl.url});
        });
      } else {
        this.schemeImgList.push({imgName: imgName, imgUrl: this.fileList[0].url});
      }
      this.calSrcList();
      // let fl = this.fileList[0];
      this.uploadDilaogVisible = false;
      this.fileList = [];
      this.uploadForm = {};
    },
    // 附件上传
    uploadSectionFile(params, file1) {
      // if (this.fileList.length > 0) {
      //   this.$message.error('最高可上传一个图片')
      //   return
      // }
      let that = this;
      const file = params.file
      const fileType = file.type
      let ft = "jpg";
      if(fileType.includes('pdf')) {
        ft = 'pdf';
      }
      // const isImage = fileType.indexOf('image') !== -1
      // const isLt2M = file.size / 1024 / 1024 < 2
      // 这里常规检验，看项目需求而定
      // if (!isImage) {
      //   this.$message.error('只能上传图片格式png、jpg、gif!')
      //   return
      // }
      // if (!isLt2M) {
      //   this.$message.error('只能上传图片大小小于2M')
      //   return
      // }
      // 将图片转成base64
      const reader = new FileReader()
      reader.readAsDataURL(file) // 开始转
      reader.onload = function(e) {
        // const _self = this
        // this.result // 这个就是base64编码了
        this.imageUrl = this.result.split('base64,')[1]
        apiUploadByBase64({
          base64: this.imageUrl,
          path: 'ChatScheme',
          suffix: ft
        }).then(res => {
          if (res.status === 0) {
            // this.$message({message: '上传成功', type: 'success'});
            let name = new Date().getTime() + "-" + file.name
            let url = that.baseImage + res.data;
            that.fileList.push({name: name, url: url});
          }
          console.log("flist", that.fileList)
        })
      }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
      },
    // 删除文件之前的钩子
    handleRemove(file) {
      this.fileList.forEach((f, i)=>{
        if(file.name == f.name) {
          console.log('i:',i);
          this.fileList.splice(i, 1);
          return;
        }
      });
    },
    // 文件超出个数限制时的钩
    handleExceed(file, fileList) {
      console.log(fileList)
      console.log(this.fileList)
      this.$message.error('最高可上传一个图片')
    },
    calSrcList() {
      this.srcList = [];
      this.schemeImgList.forEach(ri=>{
        if(!ri.imgUrl.endsWith(".pdf")) {
          this.srcList.push(ri.imgUrl);
        }
      });
    }


  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.outer-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
 
.inner-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) !important;
}
.flex {
  display: flex;
}
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  padding: 0 10px;
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 92px;
    .headSearch {
      .headSearch-left {
        width: 85%;
        float: left;
        .form-data {
          // span {
          //   width: 90px;
          // }
          /deep/ .el-date-editor,
          .el-input,
          .el-cascader {
            width: 200px;
          }
        }
      }
      .headSearch-right {
        width: 10%;
        float: right;
      }
    }
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: calc(100vh - 214px);
    /deep/ .el-table {
      overflow: auto;
      height: calc(100vh - 272px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
